/**
 * SEÇÃO DESAFIO DO HEXA - CAMADA SAZONAL (REMOVÍVEL)
 * 
 * Esta seção pode ser removida no futuro quando a promoção da Copa acabar.
 * A página continuará vendendo normalmente sem ela.
 * 
 * O contador de escassez existe APENAS aqui (faz sentido com a Copa).
 */

import { memo } from "react";
import { Trophy, Check, ArrowRight } from "lucide-react";

export const DesafioHexaSection = memo(({ sectionRef, isVisible, timeLeft, onOpenPalpiteModal }) => {
  return (
    <section 
      ref={sectionRef}
      className={`py-12 md:py-16 bg-gradient-to-b from-[#002776] to-[#001a4d] transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      data-testid="desafio-hexa-section"
    >
      <div className="max-w-4xl mx-auto px-4">
        
        {/* Título da seção */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-[#FFDF00] text-[#002776] px-4 py-2 rounded-full text-sm font-bold mb-4">
            ⚽ PROMOÇÃO ESPECIAL
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-3">
            TOPA O DESAFIO?
          </h2>
          <p className="text-lg text-white/80">
            Faça seu palpite sobre a Copa e ganhe bônus!
          </p>
        </div>
        
        {/* Card principal do desafio */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 md:p-8 border border-[#FFDF00]/30 mb-8">
          
          {/* Como funciona */}
          <div className="space-y-4 mb-6">
            
            {/* Passo 1 */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-[#FFDF00] text-[#002776] flex items-center justify-center font-black text-lg flex-shrink-0">1</div>
              <div>
                <p className="font-bold text-white">Faça seu palpite na hora da compra</p>
                <p className="text-white/70 text-sm">Brasil GANHA ou NÃO GANHA o hexa?</p>
              </div>
            </div>
            
            {/* Passo 2 */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-[#FFDF00] text-[#002776] flex items-center justify-center font-black text-lg flex-shrink-0">2</div>
              <div>
                <p className="font-bold text-white">Acertou? Escolha seu prêmio!</p>
                <div className="mt-2 space-y-2">
                  <div className="bg-[#009C3B]/30 rounded-lg p-3 border border-[#009C3B]">
                    <p className="text-white text-sm">
                      <strong className="text-[#FFDF00]">100% do valor de volta</strong> E faça o passeio por nossa conta
                    </p>
                  </div>
                  <p className="text-center text-[#FFDF00] font-bold">OU</p>
                  <div className="bg-[#009C3B]/30 rounded-lg p-3 border border-[#009C3B]">
                    <p className="text-white text-sm">
                      Ganhe o <strong className="text-[#FFDF00]">dobro de ingressos</strong> pra levar amigos ou família
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Passo 3 - Errou */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-white/20 text-white flex items-center justify-center font-bold text-lg flex-shrink-0">😄</div>
              <div>
                <p className="font-bold text-white">Errou? Sem problema!</p>
                <p className="text-white/70 text-sm">Você vai fazer um passeio inesquecível do mesmo jeito.</p>
              </div>
            </div>
            
          </div>
          
          {/* Info importante */}
          <div className="bg-white/5 rounded-xl p-4 border border-white/10">
            <p className="text-white/80 text-sm text-center">
              <strong className="text-[#FFDF00]">Trabalhamos o ano todo:</strong> use o voucher quando quiser, antes ou depois da Copa. Validade de 12 meses.
            </p>
          </div>
          
        </div>
        
        {/* CONTADOR DE ESCASSEZ - SÓ EXISTE AQUI */}
        <div className="bg-gradient-to-r from-[#dc2626] to-[#b91c1c] rounded-2xl p-4 mb-6">
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 text-white">
            <span className="text-sm font-medium">⏰ Promoção do Hexa expira em:</span>
            <span className="font-mono font-black text-2xl tracking-wider">
              {String(timeLeft.hours).padStart(2, '0')}:{String(timeLeft.minutes).padStart(2, '0')}:{String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
        </div>
        
        {/* CTA */}
        <div className="text-center">
          <button
            onClick={onOpenPalpiteModal}
            className="inline-flex items-center gap-2 bg-[#FFDF00] hover:bg-[#f5d400] text-[#002776] font-black py-4 px-8 rounded-xl shadow-lg text-lg transition-all duration-300 hover:scale-105"
          >
            QUERO PARTICIPAR DO DESAFIO
            <ArrowRight className="w-5 h-5" />
          </button>
          <p className="text-white/50 text-xs mt-3">
            R$97 por pessoa • Pagamento seguro
          </p>
        </div>
        
      </div>
    </section>
  );
});

export default DesafioHexaSection;
